export const CONVERSIONS = {
  kmh2mph: 0.621371,
  minKm2minMiles: 0.621371,
};

export const SIMP_THRESHOLD = 0.000003;
export const SIMP_DIST = 1000;

export const SPLITS_MAPPING = [
  /*   { split: 0, zoom: 99, label: "0.5" }, */
  { split: 1, zoom: 99, label: "1" },
  { split: 2, zoom: 13, label: "2" },
  { split: 3, zoom: 12, label: "5" },
  { split: 4, zoom: 11, label: "10" },
  { split: 5, zoom: 10, label: "20" },
  { split: 6, zoom: 9, label: "50" },
];
